<template>
  <dd-modal :visible="showDeleteModal"
            data-dusk="attachable-delete-modal"
  >
     <dd-header-card :header="deleteHeader">
       <div class="flex-row justify-content-end gap-md">
         <dd-button>Annuleren</dd-button>
         <dd-button @click="onConfirmation" type="danger">Verwijderen</dd-button>
       </div>
     </dd-header-card>
  </dd-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  emits: ['close'],
  name: "DeleteDocumentsModal",
  computed: {
    ...mapState(`$_attachable_widget`, {
      showDeleteModal: 'showDeleteModal',
      selectedAttachables: 'selectedAttachables',
    }),
    deleteHeader() {
      if (this.selectedAttachables.length > 1) {
        return 'Weet je zeker dat je deze geselecteerde documenten wilt verwijderen?';
      }
      return 'Weet je zeker dat je dit document wilt verwijderen?'
    },
  },
  methods: {
    ...mapActions('$_attachable_widget', {
      deleteSelected: 'deleteSelected',
    }),
    onConfirmation() {
      this.deleteSelected();
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
